import { createAction, Action, Dispatch } from '@reduxjs/toolkit';
import { stroot, organisation as organisationAPI } from '@birdi/js-sdk';
import { useSelector } from 'react-redux';

export const UPDATE = 'seats/UPDATE';

export interface SeatsState {
  loaded: boolean;
  userCount: number;
  guestCount: number;
  birdiUserCount: number;
  planData?: any;
}

const initialState: SeatsState = {
  loaded: false,
  userCount: 1,
  guestCount: 0,
  birdiUserCount: 0,
  planData: null,
};

export const updateField = createAction<Partial<SeatsState>>(UPDATE);

export const loadSeats = (dispatch: Dispatch) => {
  dispatch(updateField({ loaded: false }));
  organisationAPI
    .getSeatsCount(stroot('seatct'))
    .then((res) => dispatch(updateField({ loaded: true, ...res.body })));
};

export const seatsReducer = (state = initialState, action: Action) => {
  if (updateField.match(action)) {
    return { ...state, ...action.payload };
  }
  return state;
};

export const useSeatsSelector = () =>
  useSelector<{ seats: SeatsState }, SeatsState>((state) => state.seats);

export const totalSeats = (seats: SeatsState) => seats.userCount;
